export const CHECKOUT = 'CHECKOUT';
export const SAVE_BILLING_ADDRESS = `${CHECKOUT}/SAVE_BILLING_ADDRESS`;
export const SAVE_SHIPPING_DETAILS = `${CHECKOUT}/SAVE_SHIPPING_DETAILS`;
export const SAVE_SHOPPER_DETAILS = `${CHECKOUT}/SAVE_SHOPPER_DETAILS`;
export const CLEAR_FORM = `${CHECKOUT}/CLEAR_FORM`;
export const SET_BILLING_ADDRESS_SAME_AS_SHIPPING = `${CHECKOUT}_SET_BILLING_ADDRESS_SAME_AS_SHIPPING`;
